<template>
  <div class="schedule" >
    <el-divider content-position="left">政策管理</el-divider>
    <el-row class="mb-20 search-row" :gutter="20">
      <el-col :xs="24" :sm="8" :md="5" :lg="3">
        <el-select
          size="mini"
          filterable
          v-model="searchArr.provincesCode"
          placeholder="请选择省"
          clearable
          @change="addresscities"
        >
          <el-option
            v-for="item in provincesObj"
            :key="item.id"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="8" :md="5" :lg="3">
        <el-select
          size="mini"
          filterable
          v-model="searchArr.cityCode"
          placeholder="请选择市"
          clearable
          @change="addresstowns"
        >
          <el-option
            v-for="item in cityObj"
            :key="item.id"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="8" :md="5" :lg="3">
        <el-select
          size="mini"
          filterable
          v-model="searchArr.areaCode"
          placeholder="请选择区"
          clearable
          @change="editressareapark"
        >
          <el-option
            v-for="item in areaObj"
            :key="item.id"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="8" :md="5" :lg="3">
        <el-select
          v-model="searchArr.id"
          filterable
          remote
          reserve-keyword
          placeholder="请输政策名称"
          size="mini"
          clearable
          :remote-method="searchRemoteCftype"
          :loading="searchLoading"
        >
          <el-option
            v-for="searchCompany in searchCategories"
            :key="searchCompany.id"
            :label="searchCompany.policy_name"
            :value="searchCompany.id"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="8" :md="5" :lg="3">
        <el-select v-model="searchArr.status" filterable placeholder="请选择状态" clearable size="mini">
          <el-option :value="1" label="正常"></el-option>
          <el-option :value="2" label="删除"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="8" :md="5" :lg="3">
        <el-select v-model="searchArr.enjoy_number" placeholder="请选择享受次数" size="mini" clearable>
          <el-option :value="1" label="一次"></el-option>
          <el-option :value="2" label="多次"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="8" :md="5" :lg="3">
        <el-select v-model="searchArr.requirements" filterable placeholder="请选择企业行业" size="mini" clearable>
          <el-option v-for="item in requirementsObj" :key="item.industry_id" :label="item.industry_name"
                     :value="item.industry_id"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="8" :md="5" :lg="6" style="margin-top: 10px">
        <el-date-picker
          v-model="searchArr.start_end_time"
          size="mini"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="ysyTypeInPickerOptions"
          >
        </el-date-picker>
      </el-col>
      <el-col :xs="24" :sm="8" :md="5" :lg="6" style="margin-top: 10px">
        <el-button type="primary" size="mini" @click="loadTable">查询</el-button>
        <el-button type="danger" size="mini" @click="handleASearClear">清除</el-button>
      </el-col>
    </el-row>
    <div style="display: flex">
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="mini" @click="typeIn" >添加</el-button>
        <el-button type="primary" size="mini" @click="$router.go(-1)">返回</el-button>
      </div>
    </div>
    <el-drawer
      title="添加"
      :visible.sync="typeIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="typeForm"
          :rules="rules"
           ref="typeForm"
           label-width="100px"
        >
          <el-form-item label="政策名称：" prop="policy_name">
            <el-input v-model="typeForm.policy_name" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="省：" prop="provincesCode">
            <el-select
              filterable
              v-model="provincesObj.code"
              placeholder="请选择"
              clearable
              @change="addresscities(provincesObj.code)"
            >
              <el-option
                v-for="item in provincesObj"
                :key="item.id"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="市：" prop="cityCode">
            <el-select
              filterable
              v-model="cityObj.code"
              placeholder="请选择"
              clearable
              @change="addresstowns(cityObj.code)"
            >
              <el-option
                v-for="item in cityObj"
                :key="item.id"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区：" prop="areaCode">
            <el-select
              filterable
              v-model="areaObj.code"
              placeholder="请选择"
              clearable
              @change="addressareapark(areaObj, areaObj.code)"
            >
              <el-option
                v-for="item in areaObj"
                :key="item.id"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="园区：" prop="the_park">
            <el-select
              filterable
              v-model="typeForm.the_park"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in areaparkObj"
                :key="item.id"
                :label="item.areaName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业行业：" prop="requirements">
            <el-select
              v-model="typeForm.requirements"
              multiple placeholder="请选择"
              style="width:100%">
              <el-option
                v-for="item in requirementsObj"
                :key="item.industry_id"
                :label="item.industry_name"
                :value="item.industry_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="补贴金额：" prop="amount">
            <el-input v-model="typeForm.amount" size="mini"></el-input>
          </el-form-item>
            <el-form-item label="享受次数：" prop="enjoy_number">
              <el-select v-model="typeForm.enjoy_number" placeholder="请选择">
                <el-option label="一次" :value="1"></el-option>
                <el-option label="多次" :value="2"></el-option>
              </el-select>
            </el-form-item>
          <el-form-item label="起止时间：" prop="start_end_time">
            <el-date-picker
              v-model="typeForm.start_end_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input v-model="typeForm.sort" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="政策说明：" prop="instructions">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="typeForm.instructions">
            </el-input>
          </el-form-item>
          <el-form-item label="所需材料：" prop="material">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="typeForm.material">
            </el-input>
          </el-form-item>
          <el-form-item label="上传截图" prop="url">
                <el-card>
                  <el-row class="mt-10">
                    <el-upload
                      :action="actionHost + '/api/upload/tyc/uploadRelated'"
                      :headers="headers"
                      multiple
                      accept="image/png, image/jpeg, image/gif"
                      :on-success="handleWorkSuccess"
                      :on-preview="handleWorkPreview"
                      :on-remove="handleWorkRemove"
                      :before-upload="beforeAvatarUpload"
                      :on-change="handleAvatarChange"
                      :file-list="fileList"
                      :limit="limit"
                      list-type="picture-card">
                      <el-link type="primary">上传图片凭证</el-link>
                    </el-upload>
                    <!--:data="{id: workOrder.id, index: index}"-->
                  </el-row>
                </el-card>
          </el-form-item>
          <div style="text-align: right;margin-right: 50px;">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm('typeForm')"
            >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="编辑"
      :visible.sync="typeEditDrawer"
      :direction="direction"
      :before-close="handleCloseEtid"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="edittypeForm"
          :rules="rules"
          ref="edittypeForm"
          label-width="100px"
        >
          <el-form-item label="政策名称" prop="policy_name">
            <el-input
              v-model="edittypeForm.policy_name"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item label="省：" prop="provincesCode">
              <el-select
                filterable
                v-model="edittypeForm.provincesCode"
                placeholder="请选择"
                clearable
                size="mini"
                @change="addresscities"
              >
              <el-option
                v-for="item in provincesObj"
                :key="item.id"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="市：" prop="cityCode">
            <el-select v-model="edittypeForm.cityCode" size="mini" @change="addresstowns">
              <el-option
                v-for="item in cityObj"
                :key="item.id"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区：" prop="areaCode">
            <el-select v-model="edittypeForm.areaCode" size="mini" @change="editressareapark">
              <el-option
                v-for="item in areaObj"
                :key="item.id"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="园区：" prop="the_park">
            <el-select v-model="edittypeForm.the_park" size="mini"  >
              <el-option
                v-for="item in areaparkObj"
                :key="item.id"
                :label="item.areaName"
                :value="String(item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="enjoy_number" label="享受次数">
            <el-select v-model="edittypeForm.enjoy_number" placeholder="请选择享受次数" size="mini" clearable>
              <el-option :value="1" label="一次"></el-option>
              <el-option :value="2" label="多次"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业行业：" prop="requirements">
            <el-select
              v-model="edittypeForm.requirements"
              multiple placeholder="请选择"
              style="width:100%">
              <el-option
                v-for="item in requirementsObj"
                :key="item.industry_id"
                :label="item.industry_name"
                :value="String(item.industry_id)"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="补贴金额：" prop="amount">
            <el-input v-model="edittypeForm.amount" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="起止时间：" prop="start_end_time">
            <el-date-picker
              v-model="edittypeForm.start_end_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input v-model="edittypeForm.sort" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="政策说明：" prop="instructions">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="edittypeForm.instructions">
            </el-input>
          </el-form-item>
          <el-form-item label="所需材料：" prop="material">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="edittypeForm.material">
            </el-input>
          </el-form-item>
          <el-form-item label="上传截图/文件" prop="url">
                <el-card>
                  <el-row class="mt-10">
                    <!-- <img
                    :src="actionHost + 'storage/tyc/167055212363929a3ba9b22.jpg'"
                    class="avatar"
                    style="width: 148px;height: 148px;line-height: 146px;"
                    /> -->
                    <el-upload
                      :action="actionHost + '/api/upload/tyc/uploadRelated'"
                      :headers="headers"
                      multiple
                      accept="image/png, image/jpeg, image/gif"
                      :on-success="handleWorkSuccess"
                      :on-preview="handleWorkPreview"
                      :on-remove="handleWorkRemove"
                      :before-upload="beforeAvatarUpload"
                      :on-change="handleAvatarChange"
                      :file-list="fileList"
                      :limit="limit"
                      list-type="picture-card">
                      <el-link type="primary">上传图片凭证</el-link>
                    </el-upload>
                  </el-row>
                </el-card>
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm('edittypeForm')"
            >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title=""
      :visible.sync="companyInfoDrawer"
      direction="rtl"
      :before-close="handleClose"
      size="50%"
    >
      <template slot="title">
        <span style="color: #409eff; font-size: 0.3rem">政策关联公司</span>
      </template>
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <div style="margin-bottom: 0.28rem; color: #409eff">公司列表</div>
        <div class="block">
          <el-timeline>
            <el-timeline-item
              :timestamp="item.created_at"
              placement="top"
              v-for="item in compAll"
              :key="item.id"
            >
              <el-card>
                <h4 style="margin-bottom: 0.28rem">
                  <span>公司名称：</span><span>{{ item.company_name }}</span>
                </h4>
                <h4 style="margin-bottom: 0.28rem">
                  <span>申请状态：</span>
                  <span v-if="item.app_status === 1" style="color: #0000cc">申请中</span>
                  <span v-else-if="item.app_status === 2" style="color: green">申请成功</span>
                  <span v-else style="color: red">驳回</span>
                </h4>
                <p style="margin-bottom: 0.28rem">
                  <span>申请时间：</span><span>{{ item.apply_time }}</span>
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-drawer>

    <el-table
    height="calc(100vh - 326px)"
      :data="typeData"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column prop="id" label="ID" width="50"> </el-table-column>
      <el-table-column prop="policy_name" label="政策名称"> </el-table-column>
      <el-table-column prop="policy_name" label="绑定的公司数" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.danCount">
            <el-link
              type="primary"
              @click="handleCompanyInfo(scope.row)"
            >{{ scope.row.danCount }}
            </el-link>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="provinces" label="省"> </el-table-column>
      <el-table-column prop="city" label="市"> </el-table-column>
      <el-table-column prop="area" label="区"> </el-table-column>
      <el-table-column prop="the_park" label="园区"> </el-table-column>
      <el-table-column prop="requirements" label="企业行业"> </el-table-column>
      <el-table-column prop="amount" label="补贴金额"></el-table-column>
      <el-table-column prop="enjoy_number" label="享受次数">
        <template slot-scope="scope">
          <span v-if="scope.row.enjoy_number === 1">一次</span>
          <span v-else class="count-style">多次</span>
        </template>
      </el-table-column>
      <el-table-column prop="start_time" label="开起时间"> </el-table-column>
      <el-table-column prop="end_time" label="停止时间"> </el-table-column>
      <el-table-column prop="instructions" label="政策说明"> </el-table-column>
      <el-table-column prop="status" label="状态" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 1" style="color: green">正常</span>
            <span v-else><span style="color: red">已删除</span><br><span>{{scope.row.del_time}}</span></span>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序">
        <template slot-scope="scope" v-if="scope.row.status === 1">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.id]"
            @blur="setSort(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope" v-if="scope.row.status === 1">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <el-button
              @click.native.prevent="editRow(scope.$index, typeData)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
            >
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-refresh-left"
              circle
              @click.native.prevent="delRow(scope.$index, typeData)"
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-footer">
      <el-pagination
      class="pagination-style"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="typePerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {fscDate} from '../../../static/mixins/fastChooseDate'
export default {
  name: 'PolicyLidt',
  mixins: [fscDate],
  data () {
    var PolicyName = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请输入分类名称！'))
      }
      callback()
    }
    var ProvincesCode = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请输选择省份！'))
      }
      callback()
    }
    // var CityCode = (rule, value, callback) => {
    //   if (value.length === 0) {
    //     return callback(new Error('请输选择市！'))
    //   }
    //   callback()
    // }
    // var AreaCode = (rule, value, callback) => {
    //   if (value.length === 0) {
    //     return callback(new Error('请输选择区！'))
    //   }
    //   callback()
    // }
    var Requirements = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择企业行业！'))
      }
      callback()
    }
    var Amount = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请输入补贴金额！'))
      }
      const age = /^[0-9]*$/
      if (!age.test(value)) {
        callback(new Error('金额只能为整数'))
      }
      callback()
    }
    var EnjoyNumber = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择享受次数！'))
      }
      callback()
    }
    var StartEndTime = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请选择起止时间！'))
      }
      callback()
    }
    var Instructions = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请填写政策说明！'))
      }
      callback()
    }
    var Material = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请填写所需要的材料说明！'))
      }
      callback()
    }
    return {

      npage: 1,
      typePerPage: 30,
      total: null,
      provincesObj: {},
      cityObj: {},
      areaObj: {},
      areaparkObj: {},
      requirementsObj: {},
      searchArr: {
        provincesCode: '',
        cityCode: '',
        areaCode: '',
        id: '',
        status: '',
        enjoy_number: '',
        requirements: '',
        start_end_time: ''
      },
      listSortForm: [],
      compAll: {},
      typeData: [],
      searcher: null,
      typeEditDrawer: false,
      companyInfoDrawer: false,
      searchLoading: false,
      searchCategories: [],
      typeIndrawer: false,
      needUrl: [],
      workOrders: [],
      direction: 'rtl',
      ifDisplay: 2,
      ListIfDisplay: [],
      listSort: [],
      fileList: [],
      type: '',
      typeForm: {
        policy_name: '',
        provincesCode: '',
        cityCode: '',
        areaCode: '',
        the_park: '',
        requirements: [],
        fileList: [],
        amount: '',
        enjoy_number: '',
        start_end_time: '',
        material: '',
        sort: 0,
        instructions: ''
      },
      edittypeForm: {
        policy_name: '',
        provinces: '',
        cityCode: '',
        areaCode: '',
        the_park: '',
        requirements: [],
        amount: '',
        enjoy_number: '',
        start_end_time: '',
        sort: 0,
        instructions: '',
        material: ''
      },
      headers: {Authorization: localStorage.token},
      limit: 10,
      rules: {
        policy_name: [
          {
            validator: PolicyName,
            required: true,
            trigger: 'blur'
          }
        ],
        provincesCode: [
          {
            validator: ProvincesCode,
            required: true,
            trigger: 'change'
          }
        ],
        // cityCode: [
        //   {
        //     validator: CityCode,
        //     required: true,
        //     trigger: 'change'
        //   }
        // ],
        // areaCode: [
        //   {
        //     validator: AreaCode,
        //     required: true,
        //     trigger: 'change'
        //   }
        // ],
        requirements: [
          {
            validator: Requirements,
            required: true,
            trigger: 'change'
          }
        ],
        amount: [
          {
            validator: Amount,
            required: true,
            trigger: 'blur'
          }
        ],
        enjoy_number: [
          {
            validator: EnjoyNumber,
            required: true,
            trigger: 'change'
          }
        ],
        instructions: [
          {
            validator: Instructions,
            required: true,
            trigger: 'blur'
          }
        ],
        start_end_time: [
          {
            validator: StartEndTime,
            required: true,
            trigger: 'blur'
          }
        ],
        material: [
          {
            validator: Material,
            required: true,
            trigger: 'blur'
          }
        ]

      }
    }
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === 'development' ? '' : 'https://weixin.qiyehuo.com'
      }
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  mounted () {
    this.loadTable()
    this.addressprovinces()
  },
  methods: {
    beforeAvatarUpload (file) {
      // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt100M = file.size / (1024 * 100) < 100

      // if (!isJPG) {
      //   this.$message.error('上传图片格式为JPG或PNG!')
      //   return
      // }
      if (!isLt100M) {
        this.$message.error('上传总大小不能超过 100MB!')
        return false
      }
      // return isJPG && isLt2M
    },
    handleAvatarChange (res, file) {
      this.fileList = file
      this.change = true
    },
    handleWorkSuccess (res, file) {
      if (res.code === 0) {
        this.fileList.push({ url: res.data.signedUrl, name: file.name, uid: file.uid })
      } else {
        this.$message.error(res.msg)
      }
    },
    handleWorkPreview (file) {
      var tempwindow = window.open('_blank')
      tempwindow.location = file.url
    },
    handleWorkRemove (file, fileList) {
      this.fileList = fileList
    },
    handleCompanyInfo (row) {
      this.$axios.get('/api/admin/policy/companyinfo?pid=' + row.id + '&danCount=' + row.danCount).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.compAll = data.data.compAll
          this.companyInfoDrawer = true
        } else {
          this.areaparkObj = {}
          this.$message.error(data.msg)
        }
      })
    },
    handleASearClear () {
      this.searchArr.provincesCode = ''
      this.searchArr.cityCode = ''
      this.searchArr.areaCode = ''
      this.searchArr.id = ''
      this.searchArr.status = ''
      this.searchArr.enjoy_number = ''
      this.searchArr.requirements = ''
      this.searchArr.start_end_time = ''
      this.cityObj = {}
      this.areaObj = {}
    },
    editressareapark (e) {
      this.edittypeForm.the_park = ''
      this.edittypeForm.areaCode = e
      this.searchArr.areaCode = e
      this.$axios.get('/api/admin/policy/editareapark?areaparkCode=' + e).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.areaparkObj = data.data.areaparkObj
        } else {
          this.areaparkObj = {}
          this.$message.error(data.msg)
        }
      })
    },
    addressareapark (arreaObj, areaCode) {
      let areaparkName = ''
      this.typeForm.areaCode = areaCode
      arreaObj.forEach(function (item) {
        if (item.code === areaCode) {
          areaparkName = item.name
        }
      })
      this.$axios.get('/api/admin/policy/areapark?areaparkName=' + areaparkName).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.areaparkObj = data.data.area
        } else {
          this.areaparkObj = {}
          this.$message.error(data.msg)
        }
      })
    },
    addresstowns (e) {
      this.searchArr.cityCode = e
      this.typeForm.cityCode = e
      this.edittypeForm.cityCode = e
      this.$axios.get('/api/admin/policy/addresstowns?cityCode=' + e).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.areaObj = data.data.area
        }
      })
    },
    addresscities (e) {
      this.searchArr.provincesCode = e
      this.typeForm.provincesCode = e
      this.edittypeForm.provincesCode = e
      this.edittypeForm.cityCode = ''
      this.edittypeForm.areaCode = ''
      this.edittypeForm.the_park = ''
      this.cityObj = {}
      this.areaObj = {}
      this.areaparkObj = {}
      this.$axios.get('/api/admin/policy/addresscities?provincesCode=' + e).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.cityObj = data.data.city
        }
      })
    },
    addressprovinces () {
      this.$axios.get('/api/admin/policy/addressprovinces').then(res => {
        const { data } = res
        if (data.code === 0) {
          this.provincesObj = data.data.provinces
          this.requirementsObj = data.data.requirements
          this.cityObj = {}
          this.areaObj = {}
          this.areaparkObj = {}
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.typeForm['fileList'] = this.fileList
          this.$axios
            .post('api/admin/policy/addtypeform', { addTypeForm: this.typeForm })
            .then(res => {
              const { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
                this.resetForm('typeForm')
                this.typeIndrawer = false
                this.searchArr.provincesCode = ''
                this.searchArr.cityCode = ''
                this.searchArr.areaCode = ''
                this.typeForm.provincesCode = ''
                this.provincesObj = {}
                this.cityObj = {}
                this.areaObj = {}
                this.areaparkObj = {}
                this.fileList = []
                this.typeForm.fileList = []
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    loadTable () {
      this.$axios
        .post('api/admin/policy/policylist?page=' + this.npage, {
          params: {
            page: this.npage,
            perpage: this.typePerPage,
            searchArr: this.searchArr
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.typeData = data.data.list.data
            this.total = data.data.list.total
            this.loadRadio()
            this.loadSort()
          }
        })
        .catch()
    },
    loadRadio () {
      this.typeData.map(item => {
        if (item.status === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadSort () {
      this.typeData.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.typePerPage = val
      this.loadTable()
    },
    editRow (index, data) {
      this.fileList = []
      this.$axios
        .get('api/admin/policy/show', {
          params: {
            id: data[index].id
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.edittypeForm = data.data.find
            this.cityObj = data.data.cityObj
            this.areaObj = data.data.areaObj
            this.areaparkObj = data.data.areaparkObj
            this.fileList = data.data.find.fileList
          }
        })
        .catch()
      this.typeEditDrawer = true
    },
    delRow (index, data) {
      if (confirm('确定要删除吗') === true) {
        this.$axios
          .get('/api/admin/policy/delrowres', {
            params: {
              id: data[index].id
            }
          })
          .then(({ data }) => {
            if (data.code === 1) {
              this.$message.success(data.msg)
              this.loadTable()
            } else {
              this.$message.error(data.msg)
            }
          })
          .catch()
      }
    },
    searchRemoteCftype (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/admin/policy/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    handleSearchCftype (query) {
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    typeIn () {
      this.typeIndrawer = true
      this.fileList = []
      this.addressprovinces()
    },
    handleClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.companyInfoDrawer = false
          this.resetForm('typeForm')
          this.typeEditDrawer = false
          this.cityObj = {}
          this.areaObj = {}
          this.areaparkObj = {}
          done()
        })
        .catch(_ => {})
    },
    handleCloseEtid (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.resetForm('edittypeForm')
          done()
        })
        .catch(_ => {})
    },
    editSubmitForm (formName) {
      this.edittypeForm.fileList = this.fileList
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/admin/policy/edittypeform', {edittypeForm: this.edittypeForm})
            .then(res => {
              const { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
                this.typeEditDrawer = false
                this.searchArr.provincesCode = ''
                this.searchArr.cityCode = ''
                this.searchArr.areaCode = ''
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    setSort (row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .put('api/admin/policy/setsort', {
          id: row.id,
          sort: this.listSort[row.id]
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    }
  }
}
</script>
<style lang="stylus" scoped>
  .el-form-item{
    margin-top: 22px!important;
  }
  .el-collapse {
    border-bottom: 0;
    border-top: 0;
  }

  .el-collapse >>> .el-collapse-item__header {
    color: #4C87FC;
    font-weight: bold;
  }

  .el-collapse >>> .el-collapse-item__arrow {
    color: #4C87FC;
  }

  .el-date-editor {
    width: 100% !important;
  }
  .el-drawer__wrapper >>> .el-drawer {
                            overflow-y: auto;
                          }
  .schedule {
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
  }

  .page-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 80px;
    background: #fff;
    width: 100%;
    z-index: 2;
  }
  
  .pagination-style {
    padding-top: 25px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/pages/policy/PolicyList.vue